import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import {
  GetSurveyRespondersRequest,
  GetSurveyRespondersResponse,
  GetSurveyRespondersResponseRaw,
} from './get-survey-responders.types'

export const SURVEY_RESPONDERS_QUERY_KEY = 'useGetSurveyResponders'

export const getSurveyRespondersQueryKey = (data: GetSurveyRespondersRequest) => [
  SURVEY_RESPONDERS_QUERY_KEY,
  data,
]

export const getSurveyResponders = async (
  data: GetSurveyRespondersRequest,
  signal?: AbortSignal,
): Promise<GetSurveyRespondersResponse> => {
  const { surveyId, ...params } = data

  const response = await authAPI.get<GetSurveyRespondersResponseRaw>(
    `/survey/${surveyId}/responders`,
    { params, signal },
  )

  const { count, countSent, countDelivered, countOpened, countReplied, responders } = response.data

  return {
    count,
    responders,
    statusCounts: {
      delivered: countDelivered,
      opened: countOpened,
      replied: countReplied,
      sent: countSent,
    },
  }
}

export const useGetSurveyResponders = (data: GetSurveyRespondersRequest) => {
  return useQuery({
    enabled: !!data.surveyId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getSurveyResponders({ ...data }, signal),
    queryKey: getSurveyRespondersQueryKey(data),
  })
}
